import { http } from "@/http";

export default {
  login(payload) {
    return http.post("/api/v1/auth/login", payload);
  },
  isValidToken() {
    return http.get("/api/v1/auth/me");
  },
  recoverPassword(data) {
    return http.post("/api/v1/auth/forgot-password", data);
  },
  updatePassword(data) {
    return http.post(`/api/v1/auth/reset-password`, data)
  },
  getUserInfo() {
    return http.get("/api/v1/auth/me");
  },
};
